import React from 'react';
import { PillButton, Row, Stack, Text, Title } from 'library/ui';
import { ITeacher } from 'models';
import TadaIcon from 'assets/icons/tandempay/tada-circle.svg';

export default function InviteSuccess({
    selectedWorkers,
    onClose,
}: {
    selectedWorkers: ITeacher[];
    onClose: () => void;
}) {
    const workerNames = selectedWorkers.map((w) => w.name);
    let names = '';
    if (workerNames.length > 2) {
        names = workerNames.slice(0, -1).join(', ') + ', and ' + workerNames.slice(-1);
    } else if (workerNames.length === 2) {
        names = workerNames.join(' and ');
    } else {
        names = workerNames[0];
    }

    return (
        <Stack gap="md">
            <Row gap="sm" align="center">
                <TadaIcon style={{ width: 56, height: 56, borderRadius: '50%' }} />
                <Title size="h1">Success!</Title>
            </Row>
            <Text size="lg">
                We&apos;ve invited{' '}
                <Text size="lg" weight="bold">
                    {names}
                </Text>{' '}
                to your job.
            </Text>
            <Text tone="secondary">
                We are checking to see if they are available. You will be notified and see them on your schedule if they
                accept.
            </Text>
            <Row justify="end" fullWidth>
                <PillButton onClick={onClose}>Done</PillButton>
            </Row>
        </Stack>
    );
}
